"use client";

import React, { useState } from "react";
import { Navigation, X, Map as MapIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
const locations = [{
  id: 'hope-island',
  name: 'Hope Island Operations Hub',
  address: '2226 GLENGALLON WAY, HOPE ISLAND, QLD, 4212, Australia',
  phone: '+61485040630',
  email: 'info@benchmarkmediaconsulting.com',
  x: 50,
  y: 50
}];
export default function MetropolitanPresence() {
  const [activeLocation, setActiveLocation] = useState<string | null>(null);
  return <section data-section-id="222934" id="our-headquarters" className="w-full bg-background py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-primary/10 text-primary mb-6 border border-primary/20">
              <MapIcon className="w-4 h-4" />
              <span className="text-xs font-bold tracking-widest uppercase font-mono">Global Infrastructure</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-black text-foreground leading-tight tracking-tighter">
              Strategic <br className="hidden md:block" />
              <span className="text-primary">Intelligence.</span>
            </h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-md font-default">
            Our global network of strategy hubs provides the architectural foundation for high-performance advertising campaigns across dynamic markets.
          </p>
        </div>

        {}
        <div className="relative w-full h-[500px] md:h-[700px] bg-card rounded-sm overflow-hidden shadow-4xl border border-border/50">
          
          {}
          <svg className="absolute inset-0 w-full h-full object-cover opacity-40 pointer-events-none" viewBox="0 0 1000 700" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-primary/20" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
            
            {}
            <path d="M-100,200 Q150,100 300,300 T800,150 Q950,200 1100,100 L1100,800 L-100,800 Z" fill="currentColor" className="text-primary/5" />
            <path d="M100,-100 Q300,150 500,50 T900,250 1100,-50 L1100,-100 Z" fill="currentColor" className="text-primary/5" />

            {}
          </svg>

          {}
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10" style={{
          left: `${loc.x}%`,
          top: `${loc.y}%`
        }}>
              {}
              <Button onClick={() => setActiveLocation(activeLocation === loc.id ? null : loc.id)} variant="ghost" size="icon" className="relative -translate-x-1/2 -translate-y-1/2 focus:outline-none h-auto w-auto p-0" aria-label={`View details for ${loc.name}`}>
                {}
                <div className="absolute inset-0 bg-primary rounded-full animate-ping opacity-40 duration-1000"></div>
                
                {}
                <div className={`relative w-5 h-5 md:w-6 md:h-6 bg-primary rounded-sm flex items-center justify-center shadow-[0_0_20px_rgba(45,91,255,0.4)] border border-white/20 transition-transform duration-300 ${activeLocation === loc.id ? 'scale-125 rotate-45' : 'hover:scale-110'}`}>
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-white rounded-full"></div>
                </div>
              </Button>

              {}
              {activeLocation === loc.id && <div className="absolute z-20 bottom-full left-1/2 -translate-x-1/2 mb-4 w-72 md:w-80 bg-popover/95 backdrop-blur-md rounded-sm shadow-4xl border border-white/10 p-5 animate-in fade-in zoom-in-95 duration-200">
                  <Button onClick={() => setActiveLocation(null)} variant="ghost" size="icon" className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors bg-white/5 rounded-sm h-8 w-8" aria-label="Close details">
                    <X className="w-4 h-4" />
                  </Button>
                  
                  <div className="pr-6">
                    <h3 className="font-default font-bold text-lg text-popover-foreground mb-1 tracking-tight uppercase">{loc.name}</h3>
                    <p className="text-sm text-muted-foreground mb-4 font-default leading-relaxed">{loc.address}</p>
                    
                    <div className="space-y-2 mb-6 bg-white/5 p-3 rounded-sm border border-white/5">
                      <div className="flex items-center justify-between">
                        <span className="text-[10px] text-muted-foreground font-mono uppercase tracking-widest">Direct</span>
                        <span className="text-sm text-popover-foreground font-medium font-mono">{loc.phone}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-[10px] text-muted-foreground font-mono uppercase tracking-widest">Secure</span>
                        <span className="text-sm text-popover-foreground font-medium font-mono">{loc.email}</span>
                      </div>
                    </div>
                    
                    <Button className="w-full group bg-primary hover:bg-primary/90 text-white rounded-sm shadow-[0_0_15px_rgba(45,91,255,0.3)]" size="default">
                      <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                      Route to Hub
                    </Button>
                  </div>
                  
                  {}
                  <div className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 w-5 h-5 bg-popover/95 border-b border-r border-white/10 transform rotate-45"></div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}